import React, { ReactElement, useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useParams } from 'react-router';
import { NotFound } from '../../common/components/NotFound';
import { IResponseLive } from '../../services/api/models/response/responseLive';
import { LiveBlock } from '../live/components/LiveBlock/LiveBlock';
import emptyImage from '../../assets/png/liver_mihaishin.png';
import './LiveListPage.scss';
import { useGetListLiveMutation } from '../../services/api/apiService/liveApiService';
import {
  IOptionGlobal,
  ILiveRenderListTitle,
  LeagueLiveType,
  LiveAllDisplay,
  MethodLiveType,
  PathParams,
  VoiceLiveType,
} from '../../common/constants/globalConstants';
import { useGetListFavoriteCategoryQuery } from '../../services/api/apiProvider';
import { CategoryName } from '../category/component/CategoryName/CategoryName';

export const LiveListPage = (): ReactElement => {
  const { type } = useParams<{ type: string }>();
  const [notFound, setNotFound] = useState<boolean>();
  const [liverLeague, setLiverLeague] = useState<ILiveRenderListTitle>();
  const [loading, setLoading] = useState<boolean>();
  const [liveList, setLiveList] = useState<IResponseLive[]>();
  const liveCategoryIdState = localStorage.getItem('categoryId') || '';
  const { data: listFavoriteCategory } = useGetListFavoriteCategoryQuery();
  const [option, setOption] = useState<IOptionGlobal>({
    numOfPage: 0,
    numInPage: LiveAllDisplay,
  });

  const [getListLive] = useGetListLiveMutation();

  useEffect(() => {
    window.scrollTo(0, 0);
    getLiverLeague();
  }, [type]);

  useEffect(() => {
    if (liverLeague) {
      getLivesData();
    }
  }, [liverLeague]);

  const getLivesData = async () => {
    if (!liverLeague) {
      return;
    }
    setLoading(true);
    if (liverLeague.type === MethodLiveType.ROOKIES) {
      const data = await getListLive({
        numOfPage: option.numOfPage,
        numInPage: option.numInPage,
        method: MethodLiveType.ROOKIES,
        league: LeagueLiveType.ANY,
        voice: VoiceLiveType.ANY,
      }).unwrap();
      setLiveList(data);
    } else if (liverLeague.type === MethodLiveType.CLOVER) {
      const data = await getListLive({
        numOfPage: option.numOfPage,
        numInPage: option.numInPage,
        method: MethodLiveType.CLOVER,
        league: LeagueLiveType.ANY,
        voice: VoiceLiveType.ANY,
      }).unwrap();
      setLiveList(data);
    } else if (liverLeague.type === MethodLiveType.ATTENTION) {
      const data = await getListLive({
        numOfPage: option.numOfPage,
        numInPage: option.numInPage,
        method: MethodLiveType.ATTENTION,
        league: LeagueLiveType.ANY,
        voice: VoiceLiveType.ANY,
      }).unwrap();
      setLiveList(data);
    } else if (liverLeague.type === MethodLiveType.CATEGORY) {
      const data = await getListLive({
        numOfPage: option.numOfPage,
        numInPage: option.numInPage,
        method: MethodLiveType.CATEGORY,
        liveCategoryId: liveCategoryIdState,
        league: LeagueLiveType.ANY,
        voice: VoiceLiveType.ANY,
      }).unwrap();
      setLiveList(data);
    } else if (liverLeague.type === MethodLiveType.FAVORITE_CATEGORY) {
      const data = await getListLive({
        numOfPage: option.numOfPage,
        numInPage: option.numInPage,
        method: MethodLiveType.FAVORITE_CATEGORY,
        league: LeagueLiveType.ANY,
        voice: VoiceLiveType.ANY,
      }).unwrap();
      setLiveList(data);
    } else if (liverLeague.type === MethodLiveType.VOICE) {
      const data = await getListLive({
        numOfPage: option.numOfPage,
        numInPage: option.numInPage,
        method: MethodLiveType.VOICE,
        league: LeagueLiveType.ANY,
        voice: VoiceLiveType.ANY,
      }).unwrap();
      setLiveList(data);
    }
    setLoading(false);
  };

  const getLiverLeague = () => {
    switch (type) {
      case PathParams.HOT: {
        setLiverLeague({
          name: '注目',
          type: MethodLiveType.ATTENTION,
        });
        break;
      }
      case PathParams.CLOVER: {
        setLiverLeague({
          name: '一般',
          type: MethodLiveType.CLOVER,
        });
        break;
      }
      case PathParams.ROOKIES: {
        setLiverLeague({
          name: '新人',
          type: MethodLiveType.ROOKIES,
        });
        break;
      }
      case PathParams.FAVORITE_CATEGORY: {
        setLiverLeague({
          name: '好きなカテゴリ',
          type: MethodLiveType.FAVORITE_CATEGORY,
        });
        break;
      }
      case PathParams.VOICE: {
        setLiverLeague({
          name: 'Voice',
          type: MethodLiveType.VOICE,
        });
        break;
      }
      case PathParams.GACHIIBE: {
        setLiverLeague({
          name: 'ガチイベ',
          type: MethodLiveType.CATEGORY,
        });
        break;
      }
      case PathParams.WOMEN: {
        setLiverLeague({
          name: '女性',
          type: MethodLiveType.CATEGORY,
        });
        break;
      }
      case PathParams.MEN: {
        setLiverLeague({
          name: '男性',
          type: MethodLiveType.CATEGORY,
        });
        break;
      }
      case PathParams.CHATTING: {
        setLiverLeague({
          name: '雑談',
          type: MethodLiveType.CATEGORY,
        });
        break;
      }
      case PathParams.MUSIC: {
        setLiverLeague({
          name: '音楽',
          type: MethodLiveType.CATEGORY,
        });
        break;
      }
      case PathParams.MOM: {
        setLiverLeague({
          name: 'ママ',
          type: MethodLiveType.CATEGORY,
        });
        break;
      }
      case PathParams.COSPLAY: {
        setLiverLeague({
          name: 'コスプレ',
          type: MethodLiveType.CATEGORY,
        });
        break;
      }
      case PathParams.IDOL: {
        setLiverLeague({
          name: 'アイドル',
          type: MethodLiveType.CATEGORY,
        });
        break;
      }
      case PathParams.COMEDY: {
        setLiverLeague({
          name: 'お笑い',
          type: MethodLiveType.CATEGORY,
        });
        break;
      }
      case PathParams.GAME: {
        setLiverLeague({
          name: 'ゲーム',
          type: MethodLiveType.CATEGORY,
        });
        break;
      }
      case PathParams.STUDENT: {
        setLiverLeague({
          name: '学生',
          type: MethodLiveType.CATEGORY,
        });
        break;
      }
      case PathParams.VLIVER: {
        setLiverLeague({
          name: 'Vライバー',
          type: MethodLiveType.CATEGORY,
        });
        break;
      }
      default: {
        setNotFound(true);
      }
    }
  };

  const renderList = () => {
    if (loading) {
      return (
        <div className="live-list__loading">
          <Spinner
            animation="border"
            style={{ color: 'var(--color-primary)' }}
          />
        </div>
      );
    }

    if (!liveList || liveList.length <= 0) {
      return (
        <div className="block-group__empty">
          <img src={emptyImage} alt="empty-image" />
        </div>
      );
    }

    return liveList.map((live) => {
      return (
        <div key={live.id}>
          <LiveBlock live={live} />
        </div>
      );
    });
  };

  if (notFound) {
    return <NotFound />;
  }

  return (
    <div className="container-lg">
      <div className="live-list">
        {liverLeague?.name === '好きなカテゴリ' ? (
          <div className="live-list-category__header">
            <span className="live-list-category__header-title">
              {liverLeague?.name}
            </span>
            <div className="live-list-category__header-category-name">
              {listFavoriteCategory?.map((favorite, index) => (
                <CategoryName key={index} category={favorite}></CategoryName>
              ))}
            </div>
          </div>
        ) : (
          <div className="live-list__heading">{liverLeague?.name}</div>
        )}

        <div className="block-group__body">{renderList()}</div>
      </div>
    </div>
  );
};
